import React from 'react';
import {Modal, Table} from 'react-bootstrap';
import moment from "moment";
import {flexRender, getCoreRowModel, useReactTable} from "@tanstack/react-table";
import { formatBeijingTime } from "../api/TimeService";

const columns = [
    {
        accessorKey: 'externalType',
        header: '交易类型',
        Cell: ({cell}) => (
            <span style={{color: 'white',fontSize: '16px',}}>
        {cell.getValue()}
      </span>
        ),
    },
    {
        accessorKey: 'remark',
        header: '交易详情',
        Cell: ({cell}) => (
            <span style={{color: 'white',fontSize: '16px',}}>
        {cell.getValue()}
      </span>
        ),
    },
    {
        accessorKey: 'total',
        header: '费用(折扣后)',
        Cell: ({cell}) => (
            <span style={{color: cell.getValue()<0 ? 'red': 'green',fontSize: '16px',}}>
        {cell.getValue()/100}
      </span>
        ),
    },
    {
        accessorKey: 'created',
        header: '交易时间',
        Cell: ({cell}) => (
            <span style={{color: 'white',fontSize: '16px',}}>
        {moment(cell.getValue()).format('YYYY-MM-DD HH:mm:ss')}

      </span>
        ),
    },
];

const AgentConsumptionInfoModal = ({visible, agentConsumptionInfo, onClose}) => {

    const [isMobile, setIsMobile] = React.useState(false);
    React.useEffect(() => {
        const handleResize = () => {
            // 使用 setTimeout 实现简单的防抖
            const timer = setTimeout(() => {
                setIsMobile(window.innerWidth < 768);
            }, 100);

            return () => clearTimeout(timer);
        };

        handleResize(); // 初始化时调用
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    const table = useReactTable({
        data:agentConsumptionInfo || [],
        columns,
        getCoreRowModel: getCoreRowModel(),
    });
    return (
        <Modal show={visible} centered onHide={onClose}
               style={{'--bs-modal-margin': '2rem', '--bs-modal-width': '800px'}}>
            <Modal.Header closeButton style={{
                background: 'linear-gradient(90deg,#02C8E3 30%, #963BC8 120%)',
                borderBottomColor: 'transparent'
            }}>
                算力点消费明细
            </Modal.Header>
            <Modal.Body style={{background: '#1E2129'}}>

                <Table borderless={true} responsive="lg" variant="dark" style={{'minWidth': '700px'}}>
                    <thead >
                    {table.getHeaderGroups().map(headerGroup => (
                        <tr key={headerGroup.id}>
                            {headerGroup.headers.map(header => (
                                <th key={header.id}>
                                    {flexRender(header.column.columnDef.header, header.getContext())}
                                </th>
                            ))}
                        </tr>
                    ))}
                    </thead>
                    <tbody>
                    {table.getRowModel().rows.map(row => (
                        <tr key={row.id}>
                            {row.getVisibleCells().map(cell => (
                                <td key={cell.id}>
                                    {flexRender(cell.column.columnDef.Cell, cell.getContext())}
                                </td>
                            ))}
                        </tr>
                    ))}
                    </tbody>
                </Table>
            </Modal.Body>
        </Modal>
    );
};

export default AgentConsumptionInfoModal;